import React from "react";
import { useSelector } from "react-redux";

import EyeWinLeft from "assets/images/verboden/gif/Eye-Win-Left.gif";
import EyeCenterDown from "assets/images/verboden/gif/Eye-Center-to-Down.gif";
import useWindowSize from "components/shared/WindowResize";

const CircleTimer = (props) => {
  const { width } = useWindowSize();
  const game_code = useSelector(
    (state) => state.gameReducer?.roomObj?.game_code
  );

  const { count = 0, time = "0:0", tot = false } = props;
  const stroke = 18;
  const circleId = Math.random();
  const step = 722 / 100;

  let processColor = {
    start: "#F54C76",
    end: "#C62D87",
    className: "text-darkRed"
  };
  if (count > 25) {
    processColor = {
      start: "#FFBF5F",
      end: "#CF8618",
      className: "text-orange"
    };
  }
  if (count > 70) {
    processColor = {
      start: tot ? "#7CD64C" : "#7DF4D8",
      end: tot ? "#188F64" : "#1E8C93",
      className: tot ? "text-gr-green" : "text-lightGreen"
    };
  }
  return (
    <div className="d-table mx-auto position-relative">
      <div
        className={`position-relative timer ${
          game_code === "TOTO" && width > 1800 && "mt-5"
        }`}
      >
        <svg
          className="circle-timer-svg"
          xmlns="http://www.w3.org/2000/svg"
          width="200"
          height="200"
          viewBox="0 0 248 248"
          fill="none"
        >
          <defs>
            <linearGradient
              id={`circle-${circleId}`}
              x1="248"
              y1="124"
              x2="0"
              y2="124"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={processColor.start} />
              <stop offset="1" stopColor={processColor.end} />
            </linearGradient>
          </defs>
          <circle
            r={124 - stroke / 2}
            cx={124}
            cy={124}
            stroke={tot ? "#F2DCFF" : "#074e68"}
            style={tot ? { opacity: 0.4 } : {}}
            strokeWidth={stroke}
          />
          <circle
            r={124 - stroke / 2}
            cx={124}
            cy={124}
            stroke={`url(#circle-${circleId})`}
            strokeWidth={stroke}
            style={{
              transform: "rotate(-90deg)",
              transformOrigin: "124px 124px",
              strokeDasharray: `${step * count} 722`
            }}
          />
        </svg>
        {!tot && (
          <span className="eye-gif">
            <img src={props.buzzInfo ? EyeCenterDown : EyeWinLeft} alt="" />
          </span>
        )}
        {game_code === "TOTO" && (
          <span className="sbs-tot-guesser-image">
            <img src={props.profImg} className="sbs-tot-guesser-img" alt="" />
          </span>
        )}
      </div>
      <p className={`tot-time ${processColor.className}`}>
        {game_code === "TOT" && <span>{time}</span>}
      </p>
    </div>
  );
};

export default CircleTimer;
